import { render, staticRenderFns } from "./CategoryPopup.vue?vue&type=template&id=cc64a840&scoped=true&"
import script from "./CategoryPopup.vue?vue&type=script&lang=js&"
export * from "./CategoryPopup.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPopup.vue?vue&type=style&index=0&id=cc64a840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc64a840",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
